import React, { useState } from 'react';
import {
  Utensils, ChefHat, Sparkles, Plane, Ship, Car,
  Heart, Wine, MapPin, Waves, Flower2, Fish,
  Gauge
} from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { whatsappNumber } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

const serviceIcons = [Utensils, ChefHat, Sparkles, Plane, Ship, Car, Heart, Wine, MapPin, Waves, Flower2, Fish];
const serviceCategories = ['dining', 'dining', 'maintenance', 'transport', 'experiences', 'transport', 'wellness', 'experiences', 'experiences', 'experiences', 'experiences', 'experiences'];

const SPEEDS = [
  { label: '1×', duration: '55s' },
  { label: '2×', duration: '30s' },
  { label: '3×', duration: '15s' },
];

export const ConciergeServices = () => {
  const { t } = useLanguage();
  const services = t('concierge.services');
  const categories = t('concierge.categories');
  const [speedIndex, setSpeedIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const handleWhatsAppClick = (serviceTitle) => {
    const message = encodeURIComponent(`Hello! I'm interested in booking "${serviceTitle}" during my stay at Villa in Pietra. Could you please provide more information and pricing?`);
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const categoryColors = {
    dining: "var(--imperial-red)",
    wellness: "var(--gold-accent)",
    transport: "var(--text-primary)",
    experiences: "var(--imperial-red)",
    maintenance: "var(--gold-dark)",
  };

  const renderCard = (service, index) => {
    const IconComponent = serviceIcons[index % serviceIcons.length];
    const catKey = serviceCategories[index % serviceCategories.length];
    return (
      <Card key={index} className="concierge-card">
        <CardContent className="concierge-card-content">
          <div className="concierge-icon-wrapper">
            <IconComponent className="concierge-icon" />
          </div>
          <div className="concierge-category-badge" style={{ borderColor: categoryColors[catKey] }}>
            {typeof categories === 'object' ? categories[catKey] : catKey}
          </div>
          <h3 className="concierge-service-title">{service.title}</h3>
          <p className="concierge-service-description">{service.description}</p>
          <Button
            onClick={() => handleWhatsAppClick(service.title)}
            className="concierge-button"
            variant="outline"
            size="sm"
          >
            {t('concierge.requestWhatsApp')}
          </Button>
        </CardContent>
      </Card>
    );
  };

  return (
    <section className="concierge-section">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="section-badge">{t('concierge.badge')}</div>
          <h2 className="section-title">{t('concierge.title')}</h2>
          <p className="section-description">{t('concierge.description')}</p>
        </div>
      </div>

      {/* Marquee wrapper - full width, outside container */}
      <div
        className="concierge-marquee-wrapper"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          className="concierge-track"
          style={{
            animationDuration: SPEEDS[speedIndex].duration,
            animationPlayState: paused ? 'paused' : 'running',
          }}
        >
          {Array.isArray(services) && services.map((service, i) => renderCard(service, i))}
          {Array.isArray(services) && services.map((service, i) => renderCard(service, i + services.length))}
        </div>
      </div>

      {/* Speed controls */}
      <div className="container-custom">
        <div className="concierge-speed-controls">
          <Gauge size={16} className="concierge-speed-icon" />
          {SPEEDS.map((s, i) => (
            <button
              key={i}
              className={`concierge-speed-btn${speedIndex === i ? ' active' : ''}`}
              onClick={() => setSpeedIndex(i)}
            >
              {s.label}
            </button>
          ))}
        </div>

        <p className="concierge-note">
          <strong>Note:</strong> {t('concierge.note')}
        </p>
      </div>
    </section>
  );
};
